/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.events.rpc.LearningEventSeriesRpc
 */
import * as References from './LearningEventSeriesRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.events.rpc.LearningEventSeriesRpc#getSeriesEvents
 */
export const GET_SERIES_EVENTS_QUERY_FIELD_NAME = 'com_hubspot_academy_learning_events_rpc_LearningEventSeriesRpc_getSeriesEvents';
export const GET_SERIES_EVENTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SERIES_EVENTS_QUERY_FIELD_NAME,
  args: ['seriesId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getSeriesEventsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.events.rpc.LearningEventSeriesRpc#getEventSeries
 */
export const GET_EVENT_SERIES_QUERY_FIELD_NAME = 'com_hubspot_academy_learning_events_rpc_LearningEventSeriesRpc_getEventSeries';
export const GET_EVENT_SERIES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_EVENT_SERIES_QUERY_FIELD_NAME,
  args: ['eventId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getEventSeriesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.events.rpc.LearningEventSeriesRpc#getSeriesEventsByLanguage
 */
export const GET_SERIES_EVENTS_BY_LANGUAGE_QUERY_FIELD_NAME = 'com_hubspot_academy_learning_events_rpc_LearningEventSeriesRpc_getSeriesEventsByLanguage';
export const GET_SERIES_EVENTS_BY_LANGUAGE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SERIES_EVENTS_BY_LANGUAGE_QUERY_FIELD_NAME,
  args: ['language'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getSeriesEventsByLanguageRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});